var CookieKeys = {
  AUTH_KEY: "auth-token",
  PERMISSIONS: "permissions",
  USER_DETAILS: "user-details"
};

export default CookieKeys;
